const Footer = (props) => {
  return (
    <div className="z-1 px-8 font-inter text-white xl:px-20 2xl:px-60 p-5 flex flex-col gap-y-5 text-xs bg-[#2c3648] w-full relative overflow-hidden">
      <div className="h-80 w-80 bg-transparent-accent absolute -top-36 -right-10 z-1 blur-3xl"></div>
      <div className="z-10">
        <h1 className="text-5xl font-black">JLT DIGITAL SOLUTIONS</h1>
        <h1 className="text-2xl font-bold italic">SINCE 2023</h1>
      </div>
      <div className="grid grid-rows-3 md:grid-cols-3 md:grid-rows-1">
        {/* Social Media */}
        <div className="flex flex-col gap-y-2">
          <h1 className="font-bold">Social Media</h1>
          <a href="https://www.facebook.com/ThrifterFindsPH?notif_id=1718884643312061&notif_t=profile_plus_admin_invite&ref=notif">
            Facebook
          </a>
          <a href="https://www.instagram.com/jltdigitalsolutions/">Instagram</a>
          <a href="https://www.tiktok.com/@jltdigitalsolutions2024">Tiktok</a>
        </div>
        {/* Services */}
        <div className="flex flex-col gap-y-2">
          <h1 className="font-bold">Profiles</h1>
          <a href="https://www.upwork.com/freelancers/~01dc325fc1acf51feb">
            Upwork
          </a>
          <a href="https://www.linkedin.com/in/john-lester-talibong-234715293/?profileId=ACoAAEceeAgB5d396nSl0Xbdwp7OlpmwJRVBCwY">
            Linkedin
          </a>
          <a href="https://www.fiverr.com/john_lester21?up_rollout=true">
            Fiverr
          </a>
        </div>
        {/* Contact */}
        <div className="flex flex-col gap-y-2">
          <h1 className="font-bold">Contact</h1>
          <a href="mailto:jltdigisolutions@gmail.com">Gmail</a>
          <a href="https://web.telegram.org/a/#5795885582">Telegram</a>
          <a href="https://secure.skype.com/portal/profile">Skype</a>
          <p>PH (+63) 966 991 2467</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
